import { render } from "./ProductOrderComponent.vue?vue&type=template&id=04caa891&ts=true"
import script from "./ProductOrderComponent.vue?vue&type=script&lang=ts"
export * from "./ProductOrderComponent.vue?vue&type=script&lang=ts"

import "./ProductOrderComponent.vue?vue&type=style&index=0&id=04caa891&lang=css"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__